import { render, staticRenderFns } from "./ShareError.vue?vue&type=template&id=7d2fe818&scoped=true&"
import script from "./ShareError.vue?vue&type=script&lang=js&"
export * from "./ShareError.vue?vue&type=script&lang=js&"
import style0 from "./ShareError.vue?vue&type=style&index=0&id=7d2fe818&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2fe818",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/django/wordbox-test.astroshock.ru/application/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7d2fe818', component.options)
    } else {
      api.reload('7d2fe818', component.options)
    }
    module.hot.accept("./ShareError.vue?vue&type=template&id=7d2fe818&scoped=true&", function () {
      api.rerender('7d2fe818', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/app/front/modules/share/components/ShareError.vue"
export default component.exports